// Patch HTMLCanvasElement.getContext to set willReadFrequently: true for 2D contexts
// This addresses the Canvas2D warning about multiple readback operations using getImageData

(function () {
  const originalGetContext = HTMLCanvasElement.prototype.getContext;

  HTMLCanvasElement.prototype.getContext = function (
    contextType,
    contextAttributes = {}
  ) {
    if (contextType === "2d" || contextType === "webgl") {
      // Set willReadFrequently to true for 2D contexts to optimize frequent getImageData calls
      if (contextType === "2d") {
        contextAttributes = {
          willReadFrequently: true,
          ...contextAttributes,
        };
      }
    }

    return originalGetContext.call(this, contextType, contextAttributes);
  };
})();
